exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-1fdca2b1]{\n    margin-right: 25%;\n    margin-left: 25%;\n    margin-top: 55px;\n    text-align:center;\n}\n.field[data-v-1fdca2b1]{\n    padding:10px;\n    text-align:center;\n}\n.textlabel[data-v-1fdca2b1]{\n    white-space:nowrap;\n    color:#35495E;\n}\n.textfield[data-v-1fdca2b1]{\n    width:100%;\n}\n.title[data-v-1fdca2b1]{\n    font-size:30px;\n    font-weight:bold;\n    color:#35495E;\n}\n.smalltext[data-v-1fdca2b1]{\n    font-size: 12px;\n\tcolor: #888888;\n}\n.upload-box[data-v-1fdca2b1]{\n    width:75%;\n}\n.custom-file-input ~ .custom-file-label[data-v-1fdca2b1]::after {\n  content: 'sh';\n}\ntable[data-v-1fdca2b1] {\n    table-layout:auto;\n    margin:auto;\n    width:100%;\n    border: none;\n}\ntd[data-v-1fdca2b1] {\n    border: none;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1fdca2b1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/edit/Edit_Techdocs.vue
// module id = 680
// module chunks = 0